import React from "react";
import cn from "classnames";
import { Icon } from "@components/atoms/icon/icon";
import styles from "./chat-icon-button.module.scss";
import { ToolTip } from "../tooltip/tooltip";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { updateIsAIRagChatOpen } from "@src/reducers/your-reducer";

interface ChatIconButtonPropTypes {
  content: string;
  ariaLabel: string;
  iconName?: string;
  height?: number;
  width?: number;
}

const DEFAULT_ICON_NAME = "chat";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

const cssClassName = "chat-icon-button";
export const ChatIconButton = ({
  content,
  ariaLabel,
  iconName = DEFAULT_ICON_NAME,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
}: ChatIconButtonPropTypes) => {
  const dispatch = useDispatch();

  const isAIRagChatOpen = useSelector(
    (state: RootState) => state.yourSlice.isAIRagChatOpen,
  );

  const toggleChat = () => {
    dispatch(updateIsAIRagChatOpen(!isAIRagChatOpen));
  };

  return (
    <ToolTip position={"bottom"} content={content}>
      <button
        type="button"
        className={cn(
          styles[cssClassName],
          styles[`${cssClassName}__hover`],
          styles[`${cssClassName}__center-content`],
          isAIRagChatOpen && styles[`${cssClassName}__active`],
        )}
        onClick={toggleChat}
        aria-label={ariaLabel}
      >
        <Icon name={iconName} width={width} height={height} />
      </button>
    </ToolTip>
  );
};
